import { Action } from 'redux';
import { IVideoClip } from '../../../api/vault/clipList';
import { IAppState } from '../../../state/reducers';

export enum ActionType {
  UpdateCurrentPlayingClip = 'CurrentPlayingClip.UpdateCurrentPlayingClip',
  ResetCurrentPlayingClip = 'CurrentPlayingClip.ResetCurrentPlayingClip',
}

export interface ICurrentPlayingClipAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  index: number,
  clip: IVideoClip,
}

const INITIAL_STATE: IState = {
  index: null,
  clip: null,
};

export default function reducer(state = INITIAL_STATE, action: ICurrentPlayingClipAction) {
  switch (action.type) {
    case ActionType.UpdateCurrentPlayingClip:
      return {
        ...state,
        ...action.payload,
      };
    case ActionType.ResetCurrentPlayingClip:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export const updateCurrentPlayingClip = (clip: IVideoClip, index: number) => ({
  type: ActionType.UpdateCurrentPlayingClip,
  payload: {
    index,
    clip,
  },
});

export const resetCurrentPlayingClip = () => ({
  type: ActionType.ResetCurrentPlayingClip,
});

export const selectIsMultipleClipReviewInProgress = (state: IAppState) => (
  state.currentPlayingClip.index !== null
);

export const selectIsClipPlayed = (state: IAppState, clipIndex: number) => (
  state.currentPlayingClip.index === clipIndex
);
